<template lang="pug">
  div
    input.form-control(v-for="(keyword, index) in keywords", :key="index", :name="'pv_person[' + index + ']'", :placeholder="'検索キーワード' + index.substr(-2)", :maxlength="maxlengths[index]",  v-model="keywords[index]", @input="onInput(index, keywords[index])" data-testid="-pvkeyword")
</template>

<script>
import TextCounter from '@/components/molecules/TextCounter'
export default {
  name: 'PvKeywordsForm',
  components: { TextCounter },
  props: {
    value: {
      type: Object,
      required: false,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      keywords: {},
      maxlengths: {}
    }
  },
  watch: {
    value (newval, oldval) {
      if (newval !== oldval) {
        this.syncData(newval)
      }
    }
  },
  created () {
    this.maxlengths = this.loadMaxlengths('PvPersons')
    this.syncData(this.value)
  },
  methods: {
    syncData (keywords) {
      this.keywords = keywords
    },
    onInput (index, value) {
      const keywords = this.keywords
      keywords[index] = value
      this.$emit('input', keywords)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/forms/PvKeywordsForm.vue